/**
 * The functions below were provided by SkillJar's reps and their Help Center:
 * https://support.skilljar.com/hc/en-us/articles/360020680193-Sending-Data-to-Segment
 */

// ================================ //
// Segment Identifier => on sign-up //
// ================================ //
export function initSegement () {
    try {
        analytics.ready(function() {
            if(typeof skilljarUser !== 'undefined'){
                if(!analytics.user().traits().email){analytics.identify({'name': skilljarUser.name,'email':skilljarUser.email})};
            }
        });
    } catch(error) {
        console.warn("Segment Error", error);
    }
};

// ======================================= //
// Segment Tracker => on lesson completion //
// ======================================= //
export function segmentTrackLessonCompletion () {
    try {
        if(typeof skilljarCourse !== 'undefined'){
            if (typeof(skilljarCourse.lesson) !== 'undefined' && $('.lesson-quiz .lesson-active').length == 0 && document.domain != 'dashboard.skilljar.com') {
                analytics.track('Lesson Completed',{
                    'course_id':skilljarCourse.publishedCourseId,
                    'course_title':skilljarCourse.title,
                    'lesson_id':skilljarCourse.lesson.id,
                    'lesson_title':skilljarCourse.lesson.title
                });
                var total_lessons = $('#curriculum-list-2 a').length;
                var completed_lessons = $('#curriculum-list-2 a.lesson-complete').length;
                var lesson_progress = (completed_lessons/total_lessons).toFixed(2);
                analytics.track('Course Progress Update',{
                    'course_id':skilljarCourse.publishedCourseId,
                    'course_title':skilljarCourse.title,
                    'course_progress': Number(lesson_progress)
                })};
        }
    } catch {
        console.warn("Segment Error", error);
    }
};
